export enum NotificationItemLocations {
  ProjectActivity = 'project-activity',
  NotificationsDropdown = 'notifications-dropdown',
}
